import { GlobalClassInstance } from '@commoncore/constants/GlobalClass';
import { Controller } from '@commoncore/controller/Controller';
import { LocalStorageProps } from '@commoncore/enums/localStorageProps';
import { FileOperationsImplementation } from '@commoncore/implementation/FileOperationsImplementation';
import { DcgroupcodePickerService } from '@commoncore/services/dcgroupcode-picker.service';
import { GlobalService } from '@commoncore/services/global.service';
import { ENV_CONSTANTS } from '@env-properties/environment';
import { ENV_CONFIG } from '@env-properties/environment-config';
import { USER_DETAILS } from '../constants/Constants';
import { SHARE_DC } from '../constants/ShareDCURLs';
import { SharedFilesListImplementation } from '../implementation/SharedFilesListImplementation';

export class SharedFilesListController extends Controller{
    public enhancedShareImplementation:any;
    public fileOperationsImplementation:any;
    public router:any;
    public http:any;
    public fetchFolderData:boolean=false;
    public static singleInstance:any = null;
    public universalService:any;
    public listService:any;
  loggerService: any
  localStorageService:any;
  currentTab:any;
  shareAccessService:any;
  folderService:any;
  cleverTapEventsService:any;
  customMetadataService: any;
  containerHeightCalc:any;
  dcGroupCodePicker: any;
  sessionStorageService: any;

  public constructor(private globalService:GlobalService) {
    super(globalService);
    this.enhancedShareImplementation= SharedFilesListImplementation.getInstance(globalService);
    this.fileOperationsImplementation = FileOperationsImplementation.getInstance(globalService);
  }
    
  public static getInstance(connectionService):SharedFilesListController{
		if(this.singleInstance == null){
			this.singleInstance = new SharedFilesListController(connectionService);
			return this.singleInstance;
		}else{
			return this.singleInstance;
		}
	}

  public setEnvObjects(globalService){
		this.universalService=globalService.getUniversalServiceRef();
		this.router = globalService.getRouterRef();
    this.http = globalService.getHttpClientRef();
    this.listService = globalService.getListServiceRef();
    this.loggerService = globalService.getLoggerServiceRef();
    this.localStorageService = globalService.getLocalStorageSvcRef();
    this.sessionStorageService = globalService.getSessionStorageSvcRef();
    this.shareAccessService = globalService.getShareAccessServiceRef();
    this.folderService = globalService.getFolderServiceRef();
    this.cleverTapEventsService =  this.globalService.getCleverTapEventsvc();
    this.customMetadataService = this.globalService.getCustomMetadataServiceRef();
    this.containerHeightCalc = globalService.getContainerHeightCalculatorService();
    this.dcGroupCodePicker = DcgroupcodePickerService.getInstance(globalService);
  }

    async getSentFiles(changedSortFromDropDown){
      this.currentTab = 'sent'
      let limit = ENV_CONFIG["constants"]["PAGE_LIMIT"] * ENV_CONFIG["constants"]["PAGINATION_BUFFER"]
      var url = ENV_CONSTANTS.privateUrls[GlobalClassInstance.ENV_NAME]["nmsURL"] + ENV_CONFIG.commonUrls["nms"] + ENV_CONFIG.commonUrls["collabShare"] + ENV_CONFIG.commonUrls["sharedByMe"]  + "?page=0&limit=" + limit  + this.listService.listViewSortOrder;
      this.enhancedShareImplementation.setHandler(this.globalService);
      
      try{
        var result = await this.enhancedShareImplementation.fetchFiles(url,this.currentTab,changedSortFromDropDown);
        return result
      }catch(exc){
        console.log("exception in fetching sent objects",exc)
      }
       
    }

    async getReceivedFiles(changedSortFromDropDown){
      this.currentTab = 'received'
      let limit = ENV_CONFIG["constants"]["PAGE_LIMIT"] * ENV_CONFIG["constants"]["PAGINATION_BUFFER"]
      var url = ENV_CONSTANTS.privateUrls[GlobalClassInstance.ENV_NAME]["nmsURL"] + ENV_CONFIG.commonUrls["nms"] + ENV_CONFIG.commonUrls["collabShare"] + ENV_CONFIG.commonUrls["sharedWithMe"]  + "?page=0&limit=" + limit + this.listService.listViewSortOrder;
      this.enhancedShareImplementation.setHandler(this.globalService);
      
      try{
        var result = await this.enhancedShareImplementation.fetchFiles(url,this.currentTab,changedSortFromDropDown);
        if(result == "showPreview"){
          var obj = this.shareAccessService.singleObjectShared[0]
        
          if(obj["objectType"] == 'FR'){
            this.localStorageService.removeLocalProperty(LocalStorageProps.BREADCRUMBS)
            this.router.navigate(['/shared/sharedwithme', obj.objectKey]);
            this.openFolder(obj);
          }
          else{
            obj["previewTranscodeUrl"] = obj["imageTranscodeUrl"]
            this.universalService.hideDeleteForPublicPreviewShare = true;
            this.universalService.openPreview(obj)
          }
        }
        return result
      }catch(exc){
        console.log("exception in fetching received objects",exc)
      }
    }

    async getSharedLinkByMe(changedSortFromDropDown){
      this.currentTab = 'sharedlinkbyme';
      var sort = 'sname';

      if(this.listService.getSharedLinkByMeSortOrder() == null) {
        this.shareAccessService.sharedLinkSortType = 'sname';
        this.listService.sharedLinkByMeSortOrder = "&sort=%2DcreatedDate";
        // if(this.universalService.isMobileDevice) {
        //   this.listService.sharedLinkByMeSortOrder = "&sort=%2BshareName";
        //   this.shareAccessService.sharedLinkSortType = 'sname';
        //   sort = 'sname';
        // }
        // else{
          sort = 'cd';
        //}
      } else {
        // this.listService.sharedLinkByMeSortOrder = this.listService.getSharedLinkByMeSortOrder(changedSortFromDropDown);
        if(this.listService.sharedLinkByMeSortOrder.indexOf('createdDate')>0){
          sort = 'cd';
          this.shareAccessService.sharedLinkSortType = 'cd';
        } else {
          sort = 'sname';
          this.shareAccessService.sharedLinkSortType = 'sname';
        }
      }
      // this.listService.setSharedLinkByMeSortOrder(this.listService.sharedLinkByMeSortOrder);
      let limit = ENV_CONFIG["constants"]["PAGE_LIMIT"] * ENV_CONFIG["constants"]["PAGINATION_BUFFER"]

      var url = ENV_CONSTANTS.privateUrls[GlobalClassInstance.ENV_NAME]["shareURL"] + ENV_CONFIG.commonUrls["enhancedShareLink"] + ENV_CONFIG.commonUrls["sharedLinkByMe"]  + "?page=0&limit=" + limit  + this.listService.sharedLinkByMeSortOrder;
      this.enhancedShareImplementation.setHandler(this.globalService);
      try{
        var result = await this.enhancedShareImplementation.fetchSharedLinkByMeList(url,sort,changedSortFromDropDown);
        return result
      }catch(exc){
        console.log("exception in fetching sharedlink objects",exc)
      }
    }

    async deleteSharedLink(shareKey) {
      var self = this;
      var url = ENV_CONSTANTS.privateUrls[GlobalClassInstance.ENV_NAME]["shareURL"] + ENV_CONFIG.commonUrls["enhancedShareLink"] + "/" + shareKey + "/delete";
      this.enhancedShareImplementation.setHandler(this.globalService);
      this.cleverTapEventsService.onDeleteSharedLinkClick();
      try{
        var result = await this.enhancedShareImplementation.deleteShareLink(url);
        this.enhancedShareImplementation.deleteShareLinkFromList(shareKey, result);
      }catch(exc){
        console.log("exception in fetching sharedlink objects",exc)
      }
    }
    
    decideScrollCall(){
        if(this.listService.listOptions.api.getDisplayedRowCount() == 0) return
        if (!this.universalService.isMobileDevice) {
          this.onScrollDown();
        } 
    }

    onScrollDown() {
      var url = "";
      let apiURL = ENV_CONSTANTS.privateUrls[GlobalClassInstance.ENV_NAME]["nmsURL"]
      if (this.router.url.includes("sharedlinkbyme")) {
        apiURL = ENV_CONSTANTS.privateUrls[GlobalClassInstance.ENV_NAME]["shareURL"]
      }
      if(this.enhancedShareImplementation["nextLink"] && this.enhancedShareImplementation.nextLink.includes("sort=")) {

          if (this.enhancedShareImplementation.nextLink.includes("sort=+")) {
            this.enhancedShareImplementation.nextLink=this.enhancedShareImplementation.nextLink.replace("sort=+", "sort=%2B")
          }else if (this.enhancedShareImplementation.nextLink.includes("sort=-")) {
            this.enhancedShareImplementation.nextLink=this.enhancedShareImplementation.nextLink.replace("sort=-", "sort=%2D")
          }
      }
      url = apiURL + this.enhancedShareImplementation.nextLink;
      try {
        this.enhancedShareImplementation.setHandler(this.globalService);
        this.enhancedShareImplementation.createUrlForNextLinkOnDesktop(url,this.currentTab);
      }
      catch (exc) {
        this.loggerService.log("exception in scroll down")
      }
    }
  
    onMobileScrollDown(docheight,toppos) {
      var url = "";
      let apiURL = ENV_CONSTANTS.privateUrls[GlobalClassInstance.ENV_NAME]["nmsURL"]
      if (this.router.url.includes("sharedlinkbyme")) {
        apiURL = ENV_CONSTANTS.privateUrls[GlobalClassInstance.ENV_NAME]["shareURL"]
      }
      url = apiURL + this.enhancedShareImplementation.nextLink + this.listService.listViewSortOrder;
      try {
        this.enhancedShareImplementation.createUrlForNextLinkOnMobile(docheight, toppos, url);
      }
      catch (exc) {
        this.loggerService.log("exception in scroll down",exc)
      }
  
    }
  async updateUIAfterPerformingAction(list,executedTask){
    // var array = [] 
    // array = this.enhancedShareImplementation.sortByDateArray;
    // //array = this.universalService.sortByNameArray;
    // this.fileOperationsImplementation.setHandler(this.globalService);
    // var result = await this.fileOperationsImplementation.updateOnlyTheUI(array, list,executedTask)
    // array = result;    

    var array = [];
    array = this.enhancedShareImplementation.sortByDateArray;
    if(executedTask == 'TRASH' || executedTask == "MOVE"){
        this.fileOperationsImplementation.setHandler(this.globalService);
        if((this.universalService.showPreview && executedTask == 'TRASH')||!this.universalService.showPreview){
          var result = await this.fileOperationsImplementation.updateSummaryCountsAndUI(array,list,executedTask);
          array = result;
          this.setDataIntoFileListArray(array);
        }else{
          this.listService.deSelectAll(null);

        }
        
    }else if(executedTask == 'RENAME' || executedTask == 'SETFAV' || executedTask == 'UNSETFAV'){
        this.fileOperationsImplementation.setHandler(this.globalService);
        var result = await this.fileOperationsImplementation.updateOnlyTheUI(array, list,executedTask)
        array = result;
        this.setDataIntoFileListArray(array);
    }else{
        this.loggerService.log("task invalid",executedTask)
    }
  }

   async getFiles(tab,changedSortFromDropDown=false){
    this.universalService.showLoader = true
    this.currentTab = tab;
    this.setSelectedTab(this.currentTab);
    try{
        const currentFolderKey = this.sessionStorageService.getCurrentFolderkey(true);        
        const rootFolderKey = USER_DETAILS["USER_DETAILS"]["rootFolderKey"];
        this.universalService.openFolderContent = currentFolderKey && currentFolderKey !=rootFolderKey? true: false;
        var currentFolder = "";
        if(this.localStorageService.getCurrentFolder(true) != undefined){
          currentFolder = this.localStorageService.getCurrentFolder(true);
        }
        else{
          currentFolder = this.folderService.currentFolder;
        }
        if(currentFolder != "" && currentFolder != null && currentFolderKey != ""){
          if(!this.universalService.isMobileDevice && (!this.listService.listViewSortOrder.includes('lmd') && this.listService.listViewSortOrder == "&sort=%2BobjectName")){
            this.listService.listViewSortOrder = "&sort=%2BobjectName"
          }else if(this.universalService.isMobileDevice){
            this.listService.listViewSortOrder = "&sort=%2Dlmd"
          }
          this.enhancedShareImplementation.setHandler(this.globalService);
          await this.dcGroupCodePicker.decideTypeOfShare(currentFolder['shareKey']);
          var url = SHARE_DC["DC_URLS"]["nmsURL"] + ENV_CONFIG.commonUrls["nmsCollabShareInfo"] + '/' +currentFolder['shareKey'];
          var folderInfo = await this.enhancedShareImplementation.fetchSharedObjectMetadata(url);
          if(folderInfo == "fetchObjectMetadataAPIfailed"){
            currentFolder["editAccess"] == true ? this.universalService.showCreateFolderAndUploadButtons = true : this.universalService.showCreateFolderAndUploadButtons = false;
          }
          else{
            var folder = folderInfo.objects[0];
            this.customMetadataService.segregateData(folderInfo, this.currentTab);
            this.localStorageService.setSharedFolder(folder,true);
            folder["editAccess"] == true ? this.universalService.showCreateFolderAndUploadButtons = true : this.universalService.showCreateFolderAndUploadButtons = false;
          }
          this.enhancedShareImplementation.resetData();
          let limit = ENV_CONFIG["constants"]["PAGE_LIMIT"] * ENV_CONFIG["constants"]["PAGINATION_BUFFER"]
          await this.dcGroupCodePicker.decideTypeOfShare(currentFolder['shareKey']);
          var url = SHARE_DC["DC_URLS"]["nmsURL"] + ENV_CONFIG.commonUrls["nmsCollabShareInfo"]+ "/" +currentFolder["shareKey"] + ENV_CONFIG.commonUrls["openSharedFolder"] + "/" + currentFolderKey + "?page=0&limit=" + limit + this.listService.listViewSortOrder;
          var result = this.enhancedShareImplementation.fetchFolderData(url,tab,changedSortFromDropDown);
          this.setHeightBasedOnAccessRights();
          this.universalService.allowUpload = this.universalService.showCreateFolderAndUploadButtons;
          return result
        }else{
          this.universalService.showCreateFolderAndUploadButtons = false;
          if(tab == 'sent'){
            this.getSentFiles(changedSortFromDropDown);
          } else if (tab == 'sharedlinkbyme') {
            this.getSharedLinkByMe(changedSortFromDropDown);
          } else {
            this.getReceivedFiles(changedSortFromDropDown);
          }
          this.setHeightBasedOnAccessRights()
        }

        this.universalService.allowUpload = this.universalService.showCreateFolderAndUploadButtons;
    }catch(exc){

    }
  }

  setSelectedTab(tab){
    if(tab == 'sent'){
      jQuery("#slide-item-1").prop("checked", true);
    } else if(tab == 'received'){
      jQuery("#slide-item-2").prop("checked", true);
    } else if(tab == 'sharedlinkbyme'){
      jQuery("#slide-item-3").prop("checked", true);
    }
  }

  setHeightBasedOnAccessRights(){
    var self = this;
    var height;
    var headerheight;
    if(this.universalService.isMobileDevice){
      if(this.universalService.inAppWebViewOpened){
        headerheight= $('.pseudo-mobile-header').innerHeight()
      }else{
        headerheight = $('.pseudo-mobile-header').innerHeight()
      }
      setTimeout(() => {
        height = 120
        if(this.universalService.virtualGridEnabled) return
        self.containerHeightCalc.calculateHeight('.scrollableContainer',['.pseudo-tab'],(headerheight + height));
      }, 800);
    }else{
      setTimeout(() => {
        if (!this.universalService.isMobileDevice) {
          self.containerHeightCalc.calculateHeight('#ag-grid',['.pseudo-header','.pseudo-top-header','.pseudo-banner-container', '.shareBreadcrumb'],54);
        }
      },1000)
    }
  }

  getNextPageData(){
    var url = "";
    let apiURL = ENV_CONSTANTS.privateUrls[GlobalClassInstance.ENV_NAME]["nmsURL"]
    if (this.router.url.includes("sharedlinkbyme")) {
      apiURL = ENV_CONSTANTS.privateUrls[GlobalClassInstance.ENV_NAME]["shareURL"]
    }
    if(this.enhancedShareImplementation.nextLink && this.enhancedShareImplementation.nextLink != "") {
      url = apiURL + this.enhancedShareImplementation.nextLink;
      try {
        this.enhancedShareImplementation.fetchNextPageData(url, this.currentTab);
      }
      catch (exc) {
        this.loggerService.log("exception in scroll down")
      }
    }
  }

  selectAll(event){
    this.enhancedShareImplementation.selectAll(event)
  }

  async openFolder(folder){
    var self = this
    this.shareAccessService.sharedFilesList = [];
    this.sessionStorageService.setCurrentFolderKey(folder.objectKey, true)
    this.localStorageService.setSharedFolder(folder, true)
    this.fileOperationsImplementation.setHandler(this.globalService);
    const result = this.fileOperationsImplementation.openFolder(folder); 
    if(result == false){

    }else{
      setTimeout(() => {
        if(this.universalService.virtualGridEnabled) return
        self.containerHeightCalc.calculateHeight('.scrollableContainer',['.pseudo-header','.pseudo-top-header'],39);
      }, 1000);
    }
  }

  setDataIntoFileListArray(array){
    var objArr = [];
    array.map(function (obj) {
      objArr = objArr.concat(obj["objects"]);
    })
    this.shareAccessService.sharedFilesList = objArr;
    if(this.shareAccessService.sharedFilesList.length == 0){
      this.universalService.emptyShared = true;
    }
  }

  async getObjectMetadata(objectKey,shareKey){
    let url = ENV_CONSTANTS.privateUrls[GlobalClassInstance.ENV_NAME]["nmsURL"] + ENV_CONFIG.commonUrls["nmsCollabShare"] + ENV_CONFIG.commonUrls["metaData"] + "/" + objectKey + "/info?shareKey=" + shareKey;
    try{
      var result;
      this.enhancedShareImplementation.setHandler(this.globalService);
      result = await this.enhancedShareImplementation.getObjectMetadata(url);
      if(result){
        return result;
      }
    }catch(err){
      console.log("error in metadata",err);
      return null
    }
  }
}